import { useState } from "react";

import { Box, DialogTitle, Dialog, useTheme, useMediaQuery, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import {
    Close as CloseIcon,
    NotificationsActive as NotificationsActiveIcon,
    Pageview as ReviewIcon,
    Fingerprint as ApproveIcon
} from '@mui/icons-material';
import {
    pink,
    green
} from '@mui/material/colors';

import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";
import { FilledButton, IconButton, Typography } from "@initia-digital/component-library";
import { IPlanStatus } from "@initia-digital/types/work-and-safety";


interface IActionAPlanButtonProps {
  size?: "small" | "medium" | "large" | "vsmall"
  planId: string
  handleStatusChange: (planId: string, status: IPlanStatus, notify: boolean) => void
  status: IPlanStatus
  isAdmin: boolean
}

export const ActionAPlanButton = (props: IActionAPlanButtonProps) => {
    // -------------------------------------------------
    const { size, planId, handleStatusChange, status, isAdmin } = props;
  
    // STATE
    const [open, setOpen] = useState(false);
  
    // MUI HOOKS
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
    // EVENT HANDLERS
    const handleDialogOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
      // -------------------------
      event.stopPropagation();
      event.preventDefault();
      setOpen(false);
    }
  
    const handleDialogClose = (event: React.MouseEvent<HTMLButtonElement>) => {
      // -------------------------
      event.stopPropagation();
      event.preventDefault();
      setOpen(false);
    }
  
    const reviewClickHandler = () => {
      // ------------------------------------------------
      if (baseDefinedAndNotNullNarrowing(isAdmin)
        && baseDefinedAndNotNullNarrowing(handleStatusChange)
        && !isAdmin && status === 'DRAFT') {
        setOpen(true);
      }
      else {
        setOpen(false);
        handleStatusChange(planId, 'REVIEW', false);
      }
    }
  
  
    if (!isAdmin && status === 'DRAFT') {
      return (
        <>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleDialogOpen}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              <Box display='flex' flexDirection="row" justifyContent="space-between">
                <Typography variant="h6">{"Notify the job manager and partner?"}</Typography>
                  <IconButton
                    tooltipTitle="Close"
                    tooltipPlacement="top"
                    onClick={handleDialogClose}
                    aria-label="close"
                    color={pink[400]}
                  >
                    <CloseIcon />
                  </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                If you select yes, we send a teams or email notification to the creator, project manager and partner for this job
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <FilledButton
                size={size}
                startIcon={<NotificationsActiveIcon />}
                color={theme.palette.secondary.contrastText}
                backgroundColor={theme.palette.secondary.main}
                onClick={baseDefinedAndNotNullNarrowing(handleStatusChange) ? () => { setOpen(false); handleStatusChange(planId, 'REVIEW', true); } : undefined}
              >
                Notify team
              </FilledButton>
              <FilledButton
                size={size}
                startIcon={<ReviewIcon />}
                color={theme.palette.secondary.contrastText}
                backgroundColor={theme.palette.secondary.main}
                onClick={baseDefinedAndNotNullNarrowing(handleStatusChange) ? () => { setOpen(false); handleStatusChange(planId, 'REVIEW', false); } : undefined}
              >
                Status change only
              </FilledButton>
            </DialogActions>
          </Dialog>
          <FilledButton 
            size={size} startIcon={<ReviewIcon />} color="secondary.contrastText" backgroundColor={green[400]}
            onClick={reviewClickHandler}
          >
            Request Review
          </FilledButton>
        </>
      )
    }
    else if (!isAdmin && status === 'REVIEW') {
      // Regular user can't approve plan
      return <></>;
    }
    else if (isAdmin && status === 'DRAFT') {
      return (
        <FilledButton
            size={size}
            startIcon={<ApproveIcon />}
            color="secondary.contrastText" backgroundColor={green[400]}
            onClick={() => handleStatusChange(planId, 'APPROVED', true)}
        >
          Approve
        </FilledButton>
      )
    }
    else if (isAdmin && status === 'REVIEW') {
      // Regular user can't approve plan
      return (
        <FilledButton
            size={size}
            startIcon={<ApproveIcon />}
            color="secondary.contrastText" backgroundColor={green[400]}
            onClick={() => handleStatusChange(planId, 'APPROVED', true)}
        >
          Approve
        </FilledButton>
      )
    }
    else {
      return <></>;
    }
  }